import { useAxiosModule } from '@/modules/_shared/axios'
import { AvailableRoles, CreateEmployeePayload, EditEmployeePayload, EmployeeModel, GivPasswordPayload } from './types'
import { HistoryRecord } from '@/modules/_shared/audit-log/types'

const {
    getFromApi,
    patchToApi,
    postToApi,
    putToApi
} = useAxiosModule()

export const getEmployees = async () =>
    getFromApi<EmployeeModel[]>('employees/all')

export const getAvailableRoles = async () =>
    getFromApi<AvailableRoles>('employees/roles')

export const getSingleEmployee = async (id: string) =>
    getFromApi<EmployeeModel>('employees/' + id)

export const getEmployeeHistory = async (id: string) =>
    getFromApi<HistoryRecord[]>(`employees/${id}/history`)

export const getEmployeeActivities = async (id: string) =>
    getFromApi<HistoryRecord[]>(`employees/${id}/activities`)

export const createEmployee = async (req: CreateEmployeePayload) =>
    postToApi<string>('employees/new', req)

export const givePassword = async (req: GivPasswordPayload) =>
    putToApi<string>(`employees/${req.id}/password`, req)

export const updateEmployee = async (req: EditEmployeePayload) =>
    putToApi(`employees/${req.id}/basic-info`, req)

export const block = async (id: string) =>
    patchToApi<string>(`employees/${id}/block`)

export const unblock = async (id: string) =>
    patchToApi(`employees/${id}/unblock`)
